"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.number.is-integer");
var _device = require("@/api/device");
var _parameterManage = require("@/api/_homeCloudPlatform/parameter/parameterManage.js");
var _org = require("@/api/org");
var _user = require("@/api/user");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _transformList = _interopRequireDefault(require("./components/transformList.vue"));
var _role = require("@/api/role");
var _device2 = require("@/api/_homeCloudPlatform/mall/device.js");
var _xlsx = _interopRequireDefault(require("xlsx"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// secondary package based on el-pagination

var defaultDevice = {
  device_name: '',
  device_place: '',
  device_type: 5,
  device_number: '',
  device_model: '',
  device_attributes: '',
  // device_status: 1,
  custodian_name: '',
  custodian_contact: '',
  admin: null,
  token: '',
  uid: '',
  disc_limit: 0
};
var defaultAssignObj = {
  dept: null,
  assignComment: ''
};
var checkNumber = function checkNumber(rule, value, callBack) {
  if (!Number.isInteger(value)) {
    callBack(new Error('请输入合法的整数值'));
  } else {
    if (value < 0) {
      callBack(new Error('数值范围不在0-240'));
    } else if (value > discMaxUsedCount) {
      callBack(new Error('不能超过参数管理设置盘最多使用次数：' + discMaxUsedCount));
    } else {
      callBack();
    }
  }
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Treeselect: _vueTreeselect.default,
    UploadExcelComponent: _index.default,
    TransformList: _transformList.default
  },
  data: function data() {
    var _this = this;
    return {
      discMaxUsedCount: 960,
      device: defaultDevice,
      deviceList: {
        count: 0
      },
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 10
      },
      // typeOptions: [
      //   { key: 1, display_name: '私立医院' },
      //   { key: 2, display_name: '公立医院' }
      // ],
      typeOptions: [{
        key: 1,
        display_name: '2.1版'
      }, {
        key: 2,
        display_name: '2.0版'
      }, {
        key: 3,
        display_name: '2.2版'
      }, {
        key: 4,
        display_name: '非医有调理码'
      }, {
        key: 5,
        display_name: '非医无调理码'
      }],
      statusObj: {
        1: '离线',
        2: '待机',
        3: '工作中',
        4: '未激活',
        5: '已激活'
      },
      statusOptions: [{
        key: 1,
        display_name: '离线'
      }, {
        key: 2,
        display_name: '待机'
      }, {
        key: 3,
        display_name: '工作中'
      }, {
        key: 4,
        display_name: '未激活'
      }, {
        key: 5,
        display_name: '已激活'
      }],
      deviceOption: [{
        key: 1,
        display_name: '一般设备'
      }, {
        key: 2,
        display_name: '控释盘'
      }],
      dialogVisible: false,
      dialogType: 'new',
      rule1: {
        device_name: [{
          required: true,
          message: '请输入设备名称',
          trigger: 'blur'
        }, {
          max: 20,
          message: '输入长度不能超过20位'
        }],
        device_number: [{
          required: true,
          message: '请输入设备ID',
          trigger: 'blur'
        }, {
          max: 20,
          message: '输入长度不能超过20位字母或数字'
        }],
        device_model: [{
          required: true,
          message: '请输入设备型号',
          trigger: 'blur'
        }, {
          max: 20,
          message: '输入长度不能超过20位'
        }],
        // token: [
        //   { required: true, message: '请输入设备蓝牙地址', trigger: 'blur' },
        //   { max: 20, message: '输入长度不能超过20位' }
        // ],
        // uid: [
        //   { required: true, message: '请输入设备UID', trigger: 'blur' },
        //   { max: 100, message: '输入长度不能超过100位' }
        // ],
        device_attributes: [{
          required: true,
          message: '请选择设备分类',
          trigger: 'change'
        }],
        disc_limit: [{
          required: true,
          message: '请输入设备授权次数',
          trigger: 'blur'
        },
        // { validator: checkNumber }
        {
          validator: function validator(rule, value, callBack) {
            console.log('DDD:' + _this.discMaxUsedCount);
            if (!Number.isInteger(value)) {
              callBack(new Error('请输入合法的整数值'));
            } else {
              if (value < 0) {
                callBack(new Error('数值不能小於0'));
              } else if (value > _this.discMaxUsedCount) {
                callBack(new Error('不能超过参数管理设置盘最多使用次数：' + _this.discMaxUsedCount));
              } else {
                callBack();
              }
            }
            callBack();
            // if((value+'').length){
            //   if(value*1 > this.formModel.amount*1 || value*1 > this.applyFormModel.amount*1){
            //     callBack(`不可超过订单金额:${this.formModel.amount || this.applyFormModel.amount}`)
            //   }else{
            //     callBack()
            //   }
            // }else{
            //   callBack()
            // }
          }
        }]
        // password: [
        //   { required: true, message: '请输入密码', trigger: 'change' }
        // ],
      },
      filterOrgText: '',
      treeLoding: false,
      orgData: [],
      userData: [],
      // 批量导入
      dialogImportVisible: false,
      wholeTableData: [],
      tableData: [],
      tableHeader: [],
      headerArray: ['device_name', 'device_number', 'token', 'uid'],
      showImportButton: false,
      dialogImportLoading: false,
      headerTitle: {
        'device_name': '设备编号',
        'device_number': '设备ID',
        'device_model': '设备型号',
        'device_place': '设备存放地点',
        'custodian_name': '保管人',
        'custodian_contact': '保管人联系方式',
        'token': '设备蓝牙地址',
        'uid': '设备UID'
      },
      headerTitle1: {
        'device_name': '设备编号',
        'device_number': '设备ID',
        'device_model': '设备型号',
        'device_place': '设备存放地点',
        'custodian_name': '保管人',
        'custodian_contact': '保管人联系方式',
        'disc_limit': '设备授权次数',
        'uid': '设备UID'
      },
      // 分配历史
      dialogTransformLoading: false,
      dialogTransformVisible: false,
      transformData: null,
      // 分配
      dialogAssignVisible: false,
      dialogAssignLoading: false,
      queryLoading: false,
      filterDevices: [],
      selectedDevices: [],
      assignObj: defaultAssignObj,
      selectedDevicesData: [],
      headerAssignImportArray: ['device_number'],
      rule2: {
        dept: [{
          required: true,
          message: '请选择分配部门',
          trigger: 'blur'
        }],
        assignComment: [{
          required: true,
          message: '请输入分配说明',
          trigger: 'change'
        }]
      },
      roles: [],
      table: [],
      count: '',
      rowData: [],
      type: ''
    };
  },
  computed: {},
  watch: {
    filterOrgText: function filterOrgText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created: function created() {
    this.getList();
    this.getOrgAll();
    this.getPamameterList();
    // this.getUserAll()
    // this.getUserRoleAll()
  },
  methods: {
    checkPermission: _permission.default,
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleOrgClick: function handleOrgClick(obj, node, vue) {
      this.listQuery.page = 1;
      this.listQuery.dept = obj.id;
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      if (query.device_name === '') {
        query.device_name = function () {
          return;
        }();
      }
      if (query.device_number === '') {
        query.device_number = function () {
          return;
        }();
      }
      return query;
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _device.getDeviceList)(this.handleQuery()).then(function (response) {
        if (response.data) {
          _this2.deviceList = response.data;
          _this2.count = response.data.count;
        }
        _this2.listLoading = false;
      });
    },
    getOrgAll: function getOrgAll() {
      var _this3 = this;
      this.treeLoding = true;
      (0, _org.getOrgAll)().then(function (response) {
        _this3.orgData = (0, _utils.genTree)(response.data);
        _this3.treeLoding = false;
      });
    },
    // getUserRoleAll() {
    //   this.listQuery.type = 1
    //   getRoleAll(this.listQuery).then(response => {
    //     for (var i = 0; i < response.data.length; i++) {
    //       console.log(genTree(response.data.results))
    //       this.roles[i] = response.data.result.id
    //       console.log(response.data)
    //     }
    //   })
    // },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 20
      };
      this.getList();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    changeSort: function changeSort(value) {
      console.log('sort', value);
      this.listQuery = {
        page: 1,
        page_size: 20
      };
      var orderingField = value.prop;
      if (value.order === 'descending') {
        this.listQuery.ordering = '-' + orderingField;
      } else if (value.order === 'ascending') {
        this.listQuery.ordering = orderingField;
      }
      this.getList();
    },
    handleAddDevice: function handleAddDevice() {
      var _this4 = this;
      this.device = Object.assign({}, defaultDevice);
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this5 = this;
      this.device = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs['Form'].clearValidate();
      });
    },
    handleAssign: function handleAssign() {
      var _this6 = this;
      this.filterDevices = [];
      this.selectedDevices = [];
      this.selectedDevicesData = [];
      this.assignObj = Object.assign({}, defaultAssignObj);
      this.dialogAssignVisible = true;
      this.$nextTick(function () {
        _this6.$refs['Form2'].clearValidate();
      });
    },
    handleLargeCreate: function handleLargeCreate() {
      this.wholeTableData = [];
      this.tableData = [];
      this.tableHeader = [];
      this.showImportButton = false;
      this.dialogImportVisible = true;
      this.type = '设备';
    },
    handleLargeCreate1: function handleLargeCreate1() {
      this.wholeTableData = [];
      this.tableData = [];
      this.tableHeader = [];
      this.showImportButton = false;
      this.dialogImportVisible = true;
      this.type = '控释盘';
    },
    handlePreviewHistory: function handlePreviewHistory(scope) {
      var _this7 = this;
      this.dialogTransformVisible = true;
      this.dialogTransformLoading = true;
      (0, _device.getDeviceTransformList)({
        device_id: scope.row.id
      }).then(function (res) {
        _this7.dialogTransformLoading = false;
        _this7.transformData = res.data.results;
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this8 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _device.deleteDevice)(scope.row.id);
            case 2:
              _this8.getList();
              _this8.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleReset: function handleReset(scope) {
      var _this9 = this;
      this.$confirm('确认恢复出厂设定?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var param;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              param = [{
                "device_id": scope.row.device_number
              }];
              _context2.next = 3;
              return (0, _device2.resetDevice)(param);
            case 3:
              _this9.getList();
              _this9.$message({
                type: 'success',
                message: '已恢复出厂设定!'
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(form) {
        var _this10 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this10.dialogType === 'edit';
                  if (isEdit) {
                    (0, _device.updateDevice)(_this10.device.id, _this10.device).then(function (res) {
                      _this10.getList();
                      _this10.dialogVisible = false;
                      _this10.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _device.createDevice)(_this10.device).then(function (res) {
                      _this10.getList();
                      _this10.dialogVisible = false;
                      _this10.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    beforeUpload: function beforeUpload(file) {
      var isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      });
      return false;
    },
    handleSuccess: function handleSuccess(_ref3) {
      var _this11 = this;
      var results = _ref3.results,
        header = _ref3.header;
      var title = [];
      if (this.type === '设备') {
        title = this.headerTitle;
      } else {
        title = this.headerTitle1;
      }
      this.tableHeader = [];
      results = results.filter(function (item) {
        return item.device_name && item.device_number && String(item.device_number).trim() !== '';
      });
      results.forEach(function (item) {
        item.custodian_contact = String(item.custodian_contact);
        item.uid = String(item.uid);
      });
      this.wholeTableData = results;
      console.log(results);
      console.log(this.wholeTableData);
      this.tableData = results.length > 5 ? results.slice(0, 5) : results;
      header.forEach(function (item) {
        console.log(item);
        if (Object.keys(title).includes(item)) {
          _this11.tableHeader.push(item);
        }
      });
      this.$message({
        message: '请再点击提交按钮导入',
        type: 'success'
      });
      this.showImportButton = true;
    },
    handleFail: function handleFail() {
      this.showImportButton = false;
      this.wholeTableData = [];
      this.tableData = [];
      this.tableHeader = [];
    },
    requestPromise: function requestPromise(type, data) {
      var _this12 = this;
      return new Promise(function (resolve, reject) {
        if (type === 'create') {
          if (_this12.type === '设备') {
            data.device_attributes = 1;
          } else {
            data.device_attributes = 2;
          }
          console.log(data);
          (0, _device.createDevice)(data).then(function (res) {
            if (res.msg === 'error') {
              _this12.$message({
                message: res.data.non_field_errors[0],
                type: 'error'
              });
              reject();
              _this12.tableData.push(data);
            } else {
              resolve();
            }
          }).catch(function (error) {
            reject(error);
            _this12.tableData.push(data);
          });
        } else {
          if (_this12.type === '设备') {
            data.device_attributes = 1;
          } else {
            data.device_attributes = 2;
          }
          (0, _device.updateDevice)(data.id, data).then(function (res) {
            resolve();
          }).catch(function (error) {
            reject(error);
            // this.tableData.push(data)
          });
        }
      });
    },
    handleSubmit: function handleSubmit() {
      var _this13 = this;
      this.dialogImportLoading = true;
      this.tableData = [];
      this.showImportButton = false;
      return new Promise(function (resolve, reject) {
        return Promise.allSettled(_this13.wholeTableData.map(function (item) {
          return _this13.requestPromise('create', item);
        })).then(function (result) {
          // console.log(result)
          _this13.dialogImportLoading = false;
          resolve();
          var successCount = result.filter(function (item) {
            return item.status === 'fulfilled';
          }).length;
          var failCount = result.filter(function (item) {
            return item.status === 'rejected';
          }).length;
          if (successCount) {
            _this13.$message({
              message: "\u6210\u529F\u65B0\u5EFA".concat(successCount, "\u4E2A").concat(_this13.type),
              type: 'success',
              duration: 8000
            });
          }
          if (failCount) {
            _this13.$message({
              message: "".concat(failCount, "\u4E2A").concat(_this13.type, "\u521B\u5EFA\u5931\u8D25\uFF0C\u89C1\u4E0B\u8868"),
              type: 'error',
              duration: 8000
            });
          }
          _this13.getList();
        }).catch(function (error) {
          _this13.dialogImportLoading = false;
          reject(error);
          _this13.getList();
        });
      });
    },
    queryFilterDevice: function queryFilterDevice(query) {
      var _this14 = this;
      if (query !== '') {
        this.queryLoading = true;
        (0, _device.getDeviceList)({
          device_name: query
        }).then(function (res) {
          _this14.queryLoading = false;
          _this14.filterDevices = res.data.results;
        });
      } else {
        this.filterDevices = [];
      }
    },
    selectDevicesChange: function selectDevicesChange() {
      var _this15 = this;
      if (this.selectedDevices.length > this.selectedDevicesData.length) {
        var result = this.filterDevices.filter(function (item) {
          return item.device_number === _this15.selectedDevices[_this15.selectedDevices.length - 1];
        });
        this.selectedDevicesData.push(result[0]);
      } else {
        // const result = this.selectedDevicesData.filter(item => !this.selectedDevices.includes(String(item.device_number)))
        // this.selectedDevicesData.splice(this.selectedDevicesData.indexOf(result[0]), 1)
        this.selectedDevicesData = this.selectedDevicesData.filter(function (item) {
          return _this15.selectedDevices.includes(String(item.device_number));
        });
      }
    },
    beforeAssignImportUpload: function beforeAssignImportUpload(file) {
      var isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      });
      return false;
    },
    handleAssignImportSuccess: function handleAssignImportSuccess(_ref4) {
      var _this16 = this;
      var results = _ref4.results,
        header = _ref4.header;
      var dataList = results.filter(function (item) {
        return item.device_number && String(item.device_number).trim() !== '';
      });
      dataList.forEach(function (item) {
        if (!_this16.selectedDevices.includes(String(item.device_number))) {
          (0, _device.getDeviceList)({
            device_number: item.device_number
          }).then(function (res) {
            _this16.selectedDevices.push(String(item.device_number));
            item.id = res.data.results[0].id;
            item.device_name = res.data.results[0].device_name;
            _this16.selectedDevicesData.push(item);
          }).catch(function (error) {
            _this16.$message({
              message: "\u7F16\u53F7\uFF1A".concat(item.device_number, "\u8BBE\u5907\u4E0D\u5B58\u5728"),
              type: 'error'
            });
            _this16.selectedDevices.splice(_this16.selectedDevices.indexOf(item.device_number), 1);
            console.log(error);
          });
        }
      });
      // this.$message({
      //   message: '请再填写右侧表格后点击分配按钮',
      //   type: 'success'
      // })
      // console.log('ccc', this.selectedDevices)
      // console.log('bbb', this.selectedDevicesData)
    },
    handleAssignImportFail: function handleAssignImportFail() {
      // this.selectedDevices = []
      // this.selectedDevicesData = []
    },
    assign: function () {
      var _assign = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(form2) {
        var _this17 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[form2].validate(function (valid) {
                if (valid) {
                  if (_this17.selectedDevices.length === 0) {
                    _this17.$message({
                      message: '至少选择一个设备',
                      type: 'warning'
                    });
                  } else {
                    _this17.dialogAssignLoading = true;
                    return new Promise(function (resolve, reject) {
                      return Promise.allSettled(_this17.selectedDevicesData.map(function (item) {
                        return _this17.requestPromise('update', {
                          id: item.id,
                          device_number: item.device_number,
                          device_name: item.device_name,
                          dept: _this17.assignObj.dept,
                          roam_remark: _this17.assignObj.assignComment
                        });
                      })).then(function (result) {
                        _this17.dialogAssignLoading = false;
                        resolve();
                        var successCount = result.filter(function (item) {
                          return item.status === 'fulfilled';
                        }).length;
                        var failCount = result.filter(function (item) {
                          return item.status === 'rejected';
                        }).length;
                        if (successCount) {
                          _this17.$message({
                            message: "\u6210\u529F\u5206\u914D".concat(successCount, "\u4E2A\u8BBE\u5907"),
                            type: 'success'
                          });
                        }
                        if (failCount) {
                          _this17.$message({
                            message: "".concat(failCount, "\u4E2A\u8BBE\u5907\u5206\u914D\u5931\u8D25"),
                            type: 'error'
                          });
                        }
                        _this17.getList();
                      }).catch(function (error) {
                        _this17.dialogAssignLoading = false;
                        reject(error);
                        _this17.getList();
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function assign(_x2) {
        return _assign.apply(this, arguments);
      }
      return assign;
    }(),
    handleExport: function handleExport() {
      var _this18 = this;
      var excelData = [['设备名称', '设备编号', '设备ID', '设备型号', '设备安置地点', '所属部门', '设备类型', '保管人', '保管人联系方式', '可使用次数', '设备UID', '蓝牙地址']];
      (0, _device.getDeviceList)({
        page: 1,
        page_size: this.count
      }).then(function (response) {
        _this18.table = response.data.results;
        for (var i = 0; i < _this18.table.length; i++) {
          var type = _this18.table[i].device_type;
          var device_type = '';
          if (type !== null && type !== '') {
            device_type = _this18.typeOptions[type - 1]['display_name'];
          }
          console.log(device_type);
          _this18.rowData = [i + 1, _this18.table[i].device_name, _this18.table[i].device_number, _this18.table[i].device_model, _this18.table[i].device_place, _this18.table[i].dept_name, device_type, _this18.table[i].custodian_name, _this18.table[i].custodian_contact, _this18.table[i].disc_limit, _this18.table[i].uid, _this18.table[i].token];
          console.log(_this18.rowData);
          excelData.push(_this18.rowData);
        }
        console.log(_this18.table);
        var ws = _xlsx.default.utils.aoa_to_sheet(excelData);
        var wb = _xlsx.default.utils.book_new();
        _xlsx.default.utils.book_append_sheet(wb, ws, 'device');
        _xlsx.default.writeFile(wb, 'device.xlsx');
      });
    },
    downloadImportTemplate: function downloadImportTemplate(i) {
      var filepath = '';
      if (i == 1) {
        filepath = '/download/TTS-device-import.xlsx';
      } else {
        filepath = '/download/TTS-disc-import.xlsx';
      }
      window.open("".concat(location.origin).concat(filepath));
    },
    getPamameterList: function getPamameterList(e) {
      var _this19 = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _parameterManage.getSystemConfigurationsList)(this.listQuery).then(function (res) {
        if (res.count > 0) {
          var index = res.results.findIndex(function (x) {
            return x.system_configurations_code === 'discLimit';
          });
          if (index > -1) {
            _this19.discMaxUsedCount = res.results[index].value;
          }
        }
        _this19.listLoading = false;
      });
    }
  }
};